<template>
  <div class="signin">
    <div class="container">
      <div class="center">
        <router-link :to="{ name: 'top' }">
          <img class="logo" src="~@/assets/img/logo.png" />
        </router-link>
      </div>
      <sign-in-connected-account-form :propEmail="email" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import SignInConnectedAccountForm from "@/components/organisms/SignInConnectedAccountForm.vue";
import { checkDeprecatedBrowser } from "@/lib/checkDeprecatedBrowser";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
  components: {
    SignInConnectedAccountForm,
  },
  props: {
    email: String,
  },
  created() {
    /** 非推奨ブラウザへの文言表示 */
    checkDeprecatedBrowser();
  },
});
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";
.logo {
  width: 100px;
}

.signin {
  width: 100%;
  height: 100vh;
  color: var(--color-text-on-fixed-bg);
  background-image: url("~@/assets/img/static/top-background.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  padding: 30px;
  max-width: 500px;
  min-width: 300px;
  background-color: var(--color-surface-subtle);
  color: var(--color-text-normal);
  border-radius: var(--radius-sm);

  @include mq(sp) {
    padding: 20px 15px;
    width: 95%;
    min-width: none;
  }

  .center {
    text-align: center;
  }
}
</style>
